export const stripPhonePrefix = (phone: string | undefined | null): string => {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");
  if (digits.startsWith("66") && digits.length > 9) return digits.slice(2);
  if (digits.startsWith("0") && digits.length === 10) return digits.slice(1);
  return digits;
};

export const formatThaiPhone = (
  phone: string | undefined | null,
  fallback = "",
): string => {
  if (!phone) return fallback;
  const digits = stripPhonePrefix(phone);
  if (digits.length !== 9) return phone;
  return `+66 ${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
};
